import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, ViewChild, ElementRef, OnInit, Output, LOCALE_ID } from '@angular/core';
import { AlertService } from '../../_services/alert.service';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { DialogService } from "primeng/dynamicdialog";
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { Chart } from 'chart.js';
import jsPDF from "jspdf";
import { ActivatedRoute, Router } from "@angular/router";
import { ProformaService } from '../proforma/proforma.service'; // Change this import path to './proforma.service' in kbmresorts
import { formatCurrency } from '@angular/common';
//Remove below imports from kbmresorts
import { ProformaTargetComponent } from "./proforma-target/proforma-target.component";
import { ProformaIncomeService } from '../proforma-income/proforma-income.service';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProformaExpenseService } from '../proforma-expense/proforma-expense.service';
import { ProformaIncomeComponent } from '../proforma-income/proforma-income/proforma-income.component';
import { ProformaExpenseComponent} from '../proforma-expense/proforma-expense/proforma-expense.component';
import { ProformaIncome } from '../proforma-income/proforma-income';
import { Msg } from '../msg';
import { SendFullMailComponent } from '../msg/send-full-mail/send-full-mail.component';
import { ProformaExpense } from '../proforma-expense/proforma-expense';
//Remove above imports from kbmresorts

@Component({
    selector: 'app-proforma-view',
    templateUrl: './proforma-view.component.html',
    styleUrls: ['./proforma-view.component.css'],
    providers: [MessageService, ConfirmationService, DialogService],
    standalone: false
})
export class ProformaViewComponent implements OnInit {

  //Change isAdmin to false in kbmresorts
  isAdmin:boolean = true;
  proformaIncome: any;
  proformaIncomeId: any;
  proformaIncomes: any;
  createdBy: any;

  proformaExpense : any;
  proformaExpenseObj : any;
  proformaExpenseId : any;

  propertyLeadProfile: any;
  propertyLeadProfileId : any;
  realtorProfileId : any;
  ownerLeadProfileId : any;
  realtorProfile : any;
  ownerLeadProfile : any;
  propertyLeadProfileObj: any;

  dateOverLappingMsg: any;
  avgOccupancy: any;

  expansionOccupancy: any;
  stableOccupancy: any;
  contractionOccupancy: any;

  seasonStart = new Date();
  seasonEnd = new Date();
  proforma: any;
  ownerEmail:any;
  proformaId: any;
	proformaObj: any;
  metaInfo: any;
  formLoading = false;
  revByMonth: any;
  revGraphData: any;
  revGraphOptions: any;
  occupByMonth: any;
  avgOccpNtgsTtl: any;

  expansionAvgOccpNtgsTtl: any;
  stableAvgOccpNtgsTtl: any;
  contractionAvgOccpNtgsTtl: any;

  avgNgtRateByMonth:any;
  revanues:any;
  netRevanues:any;
  vacancyByMonth: any = {};
  occupGraphData: any;
  occupGraphOptions: any;
  doughnutData: any;
  doughnutOptions: any;

  expansionDoughnutData: any;
  stableDoughnutData: any;
  contractionDoughnutData: any;

  expansionDoughnutOptions: any;
  stableDoughnutOptions: any;
  contractionDoughnutOptions: any;

  avgNgtRateData: any;
  avgNgtRateOptions: any;
  currentProforma = 'Stable'; //stable by default
  shareProformaEmail: any = 'https://www.kbmresorts.com/proforma/CONFID/honua-kai/hkh-236';
  proformaOptions: any[] = [
    { label: 'Expansion', value: 'Expansion' },
    { label: 'Stable', value: 'Stable' },
    { label: 'Contraction', value: 'Contraction' }
  ];
  public chartDataLabelPlugins = [ChartDataLabels];
  confId: any;
  copyLinkLabel = 'Copy Link';
  copyLinkCopied = false;

  sendToProspectVisible = false;
  sendToProspectLoading = false;
  sendToProspectForm: any = { toEmail: '', subject: '', personalNote: '' };

  //Remove below variable declaration in kbmresorts
  msg: Msg;

  constructor(
    private http: HttpClient,
    private alertService: AlertService,
    private messageService: MessageService,
    private dialogService: DialogService,
	  private proformaService: ProformaService,
    private route: ActivatedRoute,
    @Inject(LOCALE_ID) public locale: string,
    //Remove below service declarations in kbmresorts
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data: any,
    private proformaExpenseService: ProformaExpenseService,
    private proformaIncomeService: ProformaIncomeService,
    )
    {
      this.confId = this.route.snapshot.params['confId'];
      //Remove below assignments in kbmresorts
     	this.proforma = data.proforma;
      this.ownerEmail = data.ownerEmail;
		  this.proformaId = data.proforma?.proformaId;
    }

      urlEndpoint = 'proforma-incomes';

  // @Input() proformaIncome: ProformaIncome;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();
  @ViewChild('viewProforma')viewProforma: ElementRef;

  ngOnInit(): void {
	  this.fetchProformaById();
  }

  onProformaOptionChange(){
    this.fetchProformaById();
  }

	fetchProformaById() {
		try {
      this.formLoading = true;
      //pass this.confId in parameter below in kbmresorts
			this.proformaService.findById(this.proformaId)
				.subscribe(
					(res: any) => {
						this.proformaObj = res.data.proforma;

            //Occupancy
            this.shareProformaEmail = this.shareProformaEmail.replace("CONFID", this.proformaObj.confId);
            this.expansionOccupancy = ((this.proformaObj.expansion.avgOccpNtgsTtlNum * 100) / 365).toFixed(0);
            this.stableOccupancy = ((this.proformaObj.stable.avgOccpNtgsTtlNum * 100) / 365).toFixed(0);
            this.contractionOccupancy = ((this.proformaObj.contraction.avgOccpNtgsTtlNum * 100) / 365).toFixed(0);

            //Nights rented
            this.expansionAvgOccpNtgsTtl = this.proformaObj.expansion.avgOccpNtgsTtlNum;
            this.stableAvgOccpNtgsTtl = this.proformaObj.stable.avgOccpNtgsTtlNum;
            this.contractionAvgOccpNtgsTtl = this.proformaObj.contraction.avgOccpNtgsTtlNum;

            // 1 = expansion, 2 = stable, 3 = contraction
            if(this.currentProforma == 'Expansion') {
              this.revByMonth = res.data.proforma.expansionRevByMonth;
              this.occupByMonth = res.data.proforma.expansionOccupByMonth;
              this.avgOccupancy = (this.proformaObj.expansion.avgOccpNtgsTtlNum * 100) / 365
              this.avgOccpNtgsTtl = this.proformaObj.expansion.avgOccpNtgsTtlNum;
              this.avgNgtRateByMonth = res.data.proforma.expansionAvgNgtRateByMonth;
              this.revanues = this.proformaObj.expansion.grossNightlyRevAmnt;
              this.netRevanues = this.proformaObj.expansion.netIncomeAmnt;
            } else if (this.currentProforma == 'Contraction') {
              this.revByMonth = res.data.proforma.contractionRevByMonth;
              this.occupByMonth = res.data.proforma.contractionOccupByMonth;
              this.avgOccupancy = (this.proformaObj.contraction.avgOccpNtgsTtlNum * 100) / 365
              this.avgOccpNtgsTtl = this.proformaObj.contraction.avgOccpNtgsTtlNum;
              this.avgNgtRateByMonth = res.data.proforma.contractionAvgNgtRateByMonth;
              this.revanues = this.proformaObj.contraction.grossNightlyRevAmnt;
              this.netRevanues = this.proformaObj.contraction.netIncomeAmnt;
            } else {
              this.revByMonth = res.data.proforma.stableRevByMonth;
              this.occupByMonth = res.data.proforma.stableOccupByMonth;
              this.avgOccupancy = (this.proformaObj.stable.avgOccpNtgsTtlNum * 100) / 365
              this.avgOccpNtgsTtl = this.proformaObj.stable.avgOccpNtgsTtlNum;
              this.avgNgtRateByMonth = res.data.proforma.stableAvgNgtRateByMonth;
              this.revanues = this.proformaObj.stable.grossNightlyRevAmnt;
              this.netRevanues = this.proformaObj.stable.netIncomeAmnt;
            }
            for (let key of Object.keys(this.occupByMonth)) {
              var value = this.occupByMonth[key];
              this.vacancyByMonth[key] = 100 - value;
            }
            this.avgOccupancy = parseFloat(this.avgOccupancy).toFixed(2);
            this.buildRevanueGraph(this.revByMonth);
            this.buildOccupGraph(this.occupByMonth, this.vacancyByMonth);
            // this.buildOccupDoughnutGraph(this.avgOccpNtgsTtl); //Pass total occupied nights
            this.buildExpansionOccupDoughnutGraph(this.expansionAvgOccpNtgsTtl) // Expansion Doughnut Graph
            this.buildStableOccupDoughnutGraph(this.stableAvgOccpNtgsTtl) // Stable Doughnut Graph
            this.buildContractionOccupDoughnutGraph(this.contractionAvgOccpNtgsTtl) // Contraction Doughnut Graph
            this.buildAvgNgtRateGraph(this.avgNgtRateByMonth);
            this.propertyLeadProfileId = res.data.proforma.propertyLeadProfileId;
            this.propertyLeadProfile = res.data.proforma.propertyLeadProfile;
            this.realtorProfileId = res.data.proforma.realtorProfileId;
            this.realtorProfile = res.data.proforma.realtorProfile;
            this.ownerLeadProfileId = res.data.proforma.ownerLeadProfileId;
            this.ownerLeadProfile = res.data.proforma.ownerLeadProfile;
						this.proformaIncomes = this.proformaObj?.proformaIncomeAPIS;
            this.proformaExpenseObj = this.proformaObj?.proformaExpenseAPIS;
            this.createdBy = this.proformaObj?.createByProfile;
            this.proformaIncomes.forEach((element:any) => {
              element.proformaId = this.proformaId;
            });
            this.proformaExpenseObj.forEach((element:any) => {
              element.proformaId = this.proformaId;
              if(element.expensePct != undefined) {
                element.customPercOrAmt = element.expensePct
              } else if(element.expenseAmnt != undefined) {
                element.customPercOrAmt = element.expenseAmnt
              }
            });
						this.dateOverLappingMsg = res.meta.Warning;
            this.formLoading = false;
            this.loadViewStats();
						return this.proformaObj;
					},
					(err:any) => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

  buildRevanueGraph(revanueByMonth:any) {
    this.revGraphData = {
      labels: Object.keys(revanueByMonth),
      datasets: [
          {
              data: Object.values(revanueByMonth),
              backgroundColor: 'orange',
              borderWidth: 1
          }
      ]
    };
    this.revGraphOptions = {
      id:'revGraph',
      layout: {
        padding: {
            left: 0,
            right: 0,
            top: 50,
            bottom: 0
        }
      },
      plugins: {
        legend: {
          display: false
        },
        ChartDataLabels,
        doughnutOccup: false,
        expansionDoughnutOccup: false,
        stableDoughnutOccup: false,
        contractionDoughnutOccup: false,
        datalabels: {
          align: 'end',
          anchor: 'end',
          borderRadius:4,
          // backgroundColor:'#D3D3D3',
          color:'black',
          font: {
            weight: 'bold'
          },
          formatter: (value:any, context:any) => {
            Math.round(value);
            return formatCurrency(value,this.locale,
              '$', '', '1.0-0');
          }
        }
      },
      scales: {
        y: {
          // suggestedMin: 0,
            ticks: {
              suggestedMin: 0,
                // color: textColorSecondary
            },
            grid: {
                // color: surfaceBorder,
                drawBorder: false
            }
        },
        x: {
            ticks: {
                // color: textColorSecondary
            },
            grid: {
                // color: surfaceBorder,
                drawBorder: false
            }
        }
      }
    };
  }

  //Build graph for occupancy of nights
  buildOccupGraph(occupByMonthByMonth:any, vacancyByMonth:any) {
    //Decimal point to upto two digits
    for (let key of Object.keys(occupByMonthByMonth)) {
      var value = occupByMonthByMonth[key];
      occupByMonthByMonth[key] = parseFloat(value).toFixed(0);
    }
    for (let key of Object.keys(vacancyByMonth)) {
      var value = vacancyByMonth[key];
      vacancyByMonth[key] = parseFloat(value).toFixed(0);
    }
    this.occupGraphData = {
      labels: Object.keys(occupByMonthByMonth),
      datasets: [
          {
              type: 'bar',
              label: 'Nights Rented %',
              backgroundColor: 'Orange',
              data: Object.values(occupByMonthByMonth)
          },
          {
              type: 'bar',
              label: '',
              backgroundColor: 'Grey',
              data: Object.values(vacancyByMonth)
          }
      ]
  };
  this.occupGraphOptions = {
    maintainAspectRatio: false,
    aspectRatio: 0.8,
    plugins: {
        legend: {
          display: true,
          position:'bottom'
        },
        tooltips: {
            mode: 'index',
            intersect: false
        },
        doughnutOccup: false,
        expansionDoughnutOccup: false,
        stableDoughnutOccup: false,
        contractionDoughnutOccup: false,
        datalabels: {
          align: 'start',
          anchor: 'end',
          // borderRadius:4,
          // backgroundColor:'teal',
          color:'black',
          font: {
            weight: 'bold'
          },
          formatter: (value:any, context:any) => {
            Math.round(value);
            return context.datasetIndex === 0 ? value + '%' : '';
          }
        }
    },
    scales: {
        x: {
            stacked: true,
            ticks: {
                // color: textColorSecondary
            },
            grid: {
                // color: surfaceBorder,
                drawBorder: false
            }
        },
        y: {
            stacked: true,
            ticks: {
                // color: textColorSecondary
            },
            grid: {
                // color: surfaceBorder,
                drawBorder: false
            }
          }
        }
      };
  }

  //Expansion doughnut chart
  buildExpansionOccupDoughnutGraph(occupByMonthByMonth:any) {
    occupByMonthByMonth = (occupByMonthByMonth).toFixed(0);
    var unrentedNgts = (365 - occupByMonthByMonth).toFixed(0);
    var rentedNgtsLbl = occupByMonthByMonth + ' Nights';
    var unRentedNgtsLbl = unrentedNgts + ' Nights';
    this.expansionDoughnutData = {
      labels: [rentedNgtsLbl, unRentedNgtsLbl],
      datasets: [
          {
              data: [occupByMonthByMonth, unrentedNgts],
              backgroundColor: ['orange', 'grey'],
          }
      ]
  };
  this.expansionDoughnutOptions = {
    cutout: '60%',
    plugins: {
        title: {
          display: true,
          text: 'Expanding'
        },
        legend: {
            position:'bottom'
        },
        contractionDoughnutOccup: false,
        stableDoughnutOccup: false,
        datalabels: {
          align: 'center',
          anchor: 'center',
          borderRadius:4,
          // backgroundColor:'#D3D3D3',
          color:'black',
          font: {
            weight: 'bold',
            size: 9
          },
          formatter: Math.round
        }
     }
    };
    var avgExpansionOccupancy = this.expansionOccupancy;
    Chart.register({
      id: 'expansionDoughnutOccup',
      afterDraw: function(chart) {
        var width = chart.width,
            height = chart.height,
            ctx = chart.ctx;

        ctx.restore();
        var fontSize = (height / 180).toFixed(2);
        ctx.font = fontSize + "em sans-serif";
        ctx.textBaseline = "middle";

        var text = avgExpansionOccupancy + '%',
            textX = Math.round((width - ctx.measureText(text).width) / 2),
            textY = height / 2.1;

        ctx.fillText(text, textX, textY);
        ctx.save();
      }
    });
  }

  //Stable doughnut chart
  buildStableOccupDoughnutGraph(occupByMonthByMonth:any) {
    occupByMonthByMonth = (occupByMonthByMonth).toFixed(0);
    var unrentedNgts = (365 - occupByMonthByMonth).toFixed(0);
    var rentedNgtsLbl = occupByMonthByMonth + ' Nights';
    var unRentedNgtsLbl = unrentedNgts + ' Nights';
    this.stableDoughnutData = {
      labels: [rentedNgtsLbl, unRentedNgtsLbl],
      datasets: [
          {
              data: [occupByMonthByMonth, unrentedNgts],
              backgroundColor: ['orange', 'grey'],
          }
      ]
  };
  this.stableDoughnutOptions = {
    cutout: '60%',
    plugins: {
        title: {
          display: true,
          text: 'Target'
        },
        legend: {
            position:'bottom'
        },
        contractionDoughnutOccup: false,
        expansionDoughnutOccup: false,
        datalabels: {
          align: 'center',
          anchor: 'center',
          borderRadius:4,
          // backgroundColor:'#D3D3D3',
          color:'black',
          font: {
            weight: 'bold',
            size: 9
          },
          formatter: Math.round
        }
     }
    };
    var avgOccupancy = this.stableOccupancy;
    Chart.register({
      id: 'stableDoughnutOccup',
      afterDraw: function(chart) {
        var width = chart.width,
            height = chart.height,
            ctx = chart.ctx;

        ctx.restore();
        var fontSize = (height / 180).toFixed(2);
        ctx.font = fontSize + "em sans-serif";
        ctx.textBaseline = "middle";

        var text = avgOccupancy + '%',
            textX = Math.round((width - ctx.measureText(text).width) / 2),
            textY = height / 2.1;

        ctx.fillText(text, textX, textY);
        ctx.save();
      }
    });
  }

  //Contraction doughnut chart
  buildContractionOccupDoughnutGraph(occupByMonthByMonth:any) {
    occupByMonthByMonth = (occupByMonthByMonth).toFixed(0);
    var unrentedNgts = (365 - occupByMonthByMonth).toFixed(0);
    var rentedNgtsLbl = occupByMonthByMonth + ' Nights';
    var unRentedNgtsLbl = unrentedNgts + ' Nights';
    this.contractionDoughnutData = {
      labels: [rentedNgtsLbl, unRentedNgtsLbl],
      datasets: [
          {
              data: [occupByMonthByMonth, unrentedNgts],
              backgroundColor: ['orange', 'grey'],
          }
      ]
  };
  this.contractionDoughnutOptions = {
    cutout: '60%',
    plugins: {
        title: {
          display: true,
          text: 'Contracting'
        },
        legend: {
            position:'bottom'
        },
        expansionDoughnutOccup: false,
        stableDoughnutOccup: false,
        datalabels: {
          align: 'center',
          anchor: 'center',
          borderRadius:4,
          // backgroundColor:'#D3D3D3',
          color:'black',
          font: {
            weight: 'bold',
            size: 9
          },
          formatter: Math.round
        }
     }
    };
    var avgOccupancy = this.contractionOccupancy;
    Chart.register({
      id: 'contractionDoughnutOccup',
      afterDraw: function(chart) {
        var width = chart.width,
            height = chart.height,
            ctx = chart.ctx;

        ctx.restore();
        var fontSize = (height / 180).toFixed(2);
        ctx.font = fontSize + "em sans-serif";
        ctx.textBaseline = "middle";

        var text = avgOccupancy + '%',
            textX = Math.round((width - ctx.measureText(text).width) / 2),
            textY = height / 2.1;

        ctx.fillText(text, textX, textY);
        ctx.save();
      }
    });
  }

  buildOccupDoughnutGraph(occupByMonthByMonth:any) {
    occupByMonthByMonth = (occupByMonthByMonth).toFixed(0);
    var unrentedNgts = (365 - occupByMonthByMonth).toFixed(0);
    var rentedNgtsLbl = occupByMonthByMonth + ' Nights';
    var unRentedNgtsLbl = unrentedNgts + ' Nights';
    this.doughnutData = {
      labels: [rentedNgtsLbl, unRentedNgtsLbl],
      datasets: [
          {
              data: [occupByMonthByMonth, unrentedNgts],
              backgroundColor: ['orange', 'grey'],
          }
      ]
  };
  this.doughnutOptions = {
    cutout: '60%',
    plugins: {
        title: {
          display: true,
          text: 'Occupancy'
        },
        legend: {
            position:'bottom'
        },
        datalabels: {
          align: 'center',
          anchor: 'center',
          borderRadius:4,
          // backgroundColor:'#D3D3D3',
          color:'black',
          font: {
            weight: 'bold'
          },
          formatter: Math.round
        }
     }
    };
    var avgOccupancy = this.avgOccupancy;
    Chart.unregister({id: 'doughnutOccup'});
    Chart.register({
      id: 'doughnutOccup',
      afterDraw: function(chart) {
        var width = chart.width,
            height = chart.height,
            ctx = chart.ctx;

        ctx.restore();
        var fontSize = (height / 114).toFixed(2);
        ctx.font = fontSize + "em sans-serif";
        ctx.textBaseline = "middle";

        var text = avgOccupancy + '%',
            textX = Math.round((width - ctx.measureText(text).width) / 2),
            textY = height / 2;

        ctx.fillText(text, textX, textY);
        ctx.save();
      }
    });
  }

  buildAvgNgtRateGraph(avgNgtRateByMonth:any) {
    this.avgNgtRateData = {
      labels: Object.keys(avgNgtRateByMonth),
      datasets: [
          {
              data: Object.values(avgNgtRateByMonth),
              fill: false,
              borderColor: 'Orange',
              tension: 0.4
          }
      ]
    };
    this.avgNgtRateOptions = {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      layout: {
        padding: {
            left: 0,
            right: 0,
            top: 50,
            bottom: 0
        }
      },
      plugins: {
          legend: {
            display: false
          },
          doughnutOccup: false,
          expansionDoughnutOccup: false,
          stableDoughnutOccup: false,
          contractionDoughnutOccup: false,
          datalabels: {
            align: 'end',
            anchor: 'end',
            clamp: true,
            borderRadius:4,
            // backgroundColor:'#D3D3D3',
          color:'black',
            font: {
              weight: 'bold'
            },
            formatter: (value:any, context:any) => {
              Math.round(value);
              return formatCurrency(value,this.locale,
                '$', '', '1.0-0');
            }
          }
      },
      elements: {
        point:
        {
            radius: 10,
            hitRadius: 5,
            hoverRadius: 15,
            hoverBorderWidth: 2,
            backgroundColor: "Orange"
        }
      },
      scales: {
          x: {
              ticks: {
                  // color: textColorSecondary
              },
              grid: {
                  // color: surfaceBorder,
                  drawBorder: false
              }
          },
          y: {
            beginAtZero: true,
            ticks: {
                callback: function(value:any, index:any, values:any) {
                  return '$' + value;
              }
            }
        },
      }
    };
  }


  public downloadPDF() {
    let self = this;
    this.formLoading = true;
    const doc = new jsPDF({compress: true});
    const elementToPrint:any = document.getElementById('viewProforma'); //The html element to become a pdf
    // doc.setFontSize(5);
    doc.html(elementToPrint, {
      html2canvas: {
        scale: 0.12 // default is window.devicePixelRatio
      },
        callback: function (doc:any) {
          self.formLoading = false;
          doc.save('proforma.pdf');
        },
        margin: [0, 5, 0, 5]
      });
    }


  //Remove below method from kbmresorts
   /*********
	 * Target Button
	 * made with primeng
	 */
   setTarget() {
		const ref = this.dialogService.open(ProformaTargetComponent, {
			data: {
				proforma: this.proformaObj,
			},
			header: "Set " + this.proformaObj.name + " target",
			width: "auto",
		});
		ref.onClose.subscribe((form1: any) => {
      this.fetchProformaById();
			this.doUpdate.emit(this.proformaObj);
		});
	}

  //Remove below method from kbmresorts
  /*********
		 * Add New Income
		 *
		 */
	onOpenIncomeAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add ProformaIncome',
			proformaId: this.proformaId

		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef:any = this.dialog.open(ProformaIncomeComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			(data:any) => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this and update the list so it shows the added element to the database
				this.addProformaIncomeCB(data);
        this.doAdd.emit(data);
				// close the dialogBox
				dialogRef.close();
			});

      dialogRef.componentInstance.getMetaInfo.subscribe(
        (data:any) => {
          this.dateOverLappingMsg = data
        });
	}

  //Remove below method from kbmresorts
  /*********
		 * Add New Income
		 *
		 */

  onOpenExpenseAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add ProformaExpense',
			proformaId: this.proformaId

		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef:any = this.dialog.open(ProformaExpenseComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addProformaExpenseCB(data);
        this.doAdd.emit(data);
				// close the dialogBox
				dialogRef.close();
			});

      dialogRef.componentInstance.getMetaInfo.subscribe(
        (data:any) => {
          this.dateOverLappingMsg = data
        });
	}

  //Remove below method from kbmresorts
  /*********
		* Edit Income
		*
		*/
    onOpenIncomeUpdate(proformaIncome: ProformaIncome) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			proformaIncome: proformaIncome,
			title: 'Edit ProformaIncome'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef:any = this.dialog.open(ProformaIncomeComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			(data:any) => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateProformaIncomeCB(data);

				// close the dialogBox
				dialogRef.close();
			});

    	dialogRef.componentInstance.getMetaInfo.subscribe(
        (data:any) => {
          this.dateOverLappingMsg = data
        });

		dialogRef.componentInstance.doDelete.subscribe(
			(data:any) => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this update the list so it shows the added element to the database
				this.fetchProformaById();
        this.doDelete.emit(proformaIncome);
				// close the dialogBox
				dialogRef.close();
			});
	}

  //Remove below method from kbmresorts
  /*********
		* Edit Income
		*
		*/
    onOpenExpenseUpdate(proformaExpense: any) {

      const dialogConfig = new MatDialogConfig();

      // settings
      dialogConfig.disableClose = false;
      dialogConfig.autoFocus = true;
      dialogConfig.hasBackdrop = true;

      // pass data, ie rateBuicket: this.shortTermRentalId,
      dialogConfig.data = {
        proformaExpense: proformaExpense,
        title: 'Edit ProformaExpense'
      };

      // open the popup and get a reference to it called dialogRef
      const dialogRef:any = this.dialog.open(ProformaExpenseComponent, dialogConfig);


      // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
      dialogRef.componentInstance.doUpdate.subscribe(
        (data:any) => {
          console.log('Dialog output:', data);

          // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
          this.updateProformaExpenseCB(data);

          // close the dialogBox
          dialogRef.close();
        });

      dialogRef.componentInstance.getMetaInfo.subscribe(
        (data:any) => {
          this.dateOverLappingMsg = data
        });

      dialogRef.componentInstance.doDelete.subscribe(
        (data:any) => {
          console.log('Dialog output:', data);

          // when we doAdd in the element, call this update the list so it shows the added element to the database
          this.fetchProformaById();

          //  this.deleteProformaExpenseCB(data);
          this.doDelete.emit(proformaExpense);
          // close the dialogBox
          dialogRef.close();
        });
    }

  //Remove below method from kbmresorts
  updateProformaExpenseCB(proformaExpense: ProformaExpense) {
    this.fetchProformaById();
    this.doUpdate.emit(proformaExpense);
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ProformaExpense ' + proformaExpense.proformaExpenseId + ' Updated', life: 3000 });
  }

  //Remove below method from kbmresorts
  updateProformaIncomeCB(proformaIncome: ProformaIncome) {

    this.fetchProformaById();
    this.doUpdate.emit(proformaIncome);

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ProformaIncome ' + proformaIncome.proformaIncomeId + ' Updated', life: 3000 });
	}

  /**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
  //Remove below method from kbmresorts
	addProformaIncomeCB(proformaIncome: ProformaIncome) {

		this.fetchProformaById();

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ProformaIncome ' + proformaIncome.proformaIncomeId + ' Added', life: 3000 });
	}

  //Remove below method from kbmresorts
	addProformaExpenseCB(proformaExpense: ProformaExpense) {

		this.fetchProformaById();

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Proforma Expense ' + proformaExpense.proformaExpenseId + ' Added', life: 3000 });
	}

  viewStats: { viewCount: number; lastViewedAt: string | null } | null = null;
  viewStatsLoading = false;

  loadViewStats() {
    if (!this.proformaId) { return; }
    this.viewStatsLoading = true;
    this.proformaService.getViewStats(this.proformaId).subscribe({
      next: (res: any) => {
        this.viewStats = res?.data?.viewStats ?? null;
        this.viewStatsLoading = false;
      },
      error: () => {
        this.viewStatsLoading = false;
      }
    });
  }

  formatLastViewed(dateStr: string | null): string {
    if (!dateStr) { return ''; }
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) { return dateStr; }
    return (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear();
  }

  copyLink() {
    if (!this.proformaObj?.confId) { return; }
    const url = 'https://www.kbmresorts.com/bizdev/' + this.proformaObj.confId;
    navigator.clipboard.writeText(url).then(() => {
      this.copyLinkLabel = 'Copied!';
      this.copyLinkCopied = true;
      setTimeout(() => {
        this.copyLinkLabel = 'Copy Link';
        this.copyLinkCopied = false;
      }, 2000);
    }).catch(() => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to copy link', life: 3000 });
    });
  }

  openSendToProspect() {
    this.sendToProspectForm = {
      toEmail: this.ownerLeadProfile?.emailAddress ?? this.ownerEmail ?? '',
      subject: 'Your Rental Income Analysis from KBM Resorts',
      personalNote: ''
    };
    this.sendToProspectVisible = true;
  }

  submitSendToProspect() {
    if (!this.sendToProspectForm.toEmail || !this.sendToProspectForm.toEmail.trim()) {
      this.messageService.add({ severity: 'warn', summary: 'Required', detail: 'Please enter a recipient email address.', life: 3000 });
      return;
    }
    this.sendToProspectLoading = true;
    const payload = {
      proformaId: this.proformaId,
      recipientEmail: this.sendToProspectForm.toEmail.trim(),
      customSubject: this.sendToProspectForm.subject.trim(),
      customMessage: this.sendToProspectForm.personalNote.trim()
    };
    this.proformaService.sendProformaToOwner(payload).subscribe({
      next: () => {
        this.sendToProspectLoading = false;
        this.sendToProspectVisible = false;
        this.messageService.add({ severity: 'success', summary: 'Sent', detail: 'Rental Income Analysis sent to ' + payload.recipientEmail, life: 4000 });
      },
      error: (err: any) => {
        this.sendToProspectLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to send email. Please try again.', life: 4000 });
        console.error('sendProformaToOwner error', err);
      }
    });
  }

  //Remove below method from kbmresorts
  sendFullMail() {
    let propertyName = "";
    if(this.propertyLeadProfile?.subjAdrDevelopmentName != undefined)  {
      propertyName = propertyName + this.propertyLeadProfile?.subjAdrDevelopmentName;
    }
    if(this.propertyLeadProfile?.subjAdrUnit != undefined) {
      propertyName = propertyName == "" ? '#' + this.propertyLeadProfile?.subjAdrUnit : propertyName + " #" + this.propertyLeadProfile?.subjAdrUnit;
    }
    if(this.propertyLeadProfile?.subjAdrStreet != undefined && propertyName == "") {
      propertyName = this.propertyLeadProfile?.subjAdrStreet;
    }

    let regards = '';
    regards = this.createdBy?.firstName != undefined ? this.createdBy?.firstName : '';
    regards = this.createdBy?.lastName != undefined ? regards == '' ? this.createdBy?.lastName : regards + ', ' + this.createdBy?.lastName: regards + '';
    regards = regards == '' ? this.createdBy?.emailAddress != undefined ? this.createdBy?.emailAddress : '' : regards + '<br>' + (this.createdBy?.emailAddress != undefined ? this.createdBy?.emailAddress : '');
    regards = regards == '' ? (this.createdBy?.mobilePhone != undefined ? this.createdBy?.mobilePhone : '') : (regards + '<br>' + (this.createdBy?.mobilePhone != undefined ? this.createdBy?.mobilePhone : ''));
    regards = regards == '' ? (this.createdBy?.title != undefined ? this.createdBy?.title : '') : (regards + '<br>' + (this.createdBy?.title != undefined ? this.createdBy?.title : ''));

    const dialogConfig = new MatDialogConfig();
    this.msg = new Msg();
    this.msg.subject = 'Proforma Details';
    this.msg.emailHtml = 'Hi ' + this.ownerLeadProfile?.firstName
    + ' <br> <br> Please find your rent analysis for ' + propertyName
    + ' <br> <br> <a href="'+ this.shareProformaEmail +'">'+ this.shareProformaEmail +'</a>'
    + ' <br> <br> Please explore the income potential by selecting between Stable, Contracting, and Expanding markets to see how our analysis indicates your home will perform under varying economic conditions.'
    + '<br> <br> I look forward to learning more about your home and am available to discuss anytime at your convenience. <br> <br>'
    + 'Best, <br>'
    + regards;

    this.msg.topic = 700; //proforma
    this.msg.topicId = this.proformaId;

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: "send mail",
      msg: this.msg,
      toEmails: this.ownerEmail,
      ccEmails: '',
      bccEmails: ''
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef:any = this.dialog.open(SendFullMailComponent, dialogConfig);

    dialogRef.componentInstance.doAdd.subscribe((data:any) => {
      console.log("Dialog output:", data);
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Proforma ' + this.proformaObj?.name + ' shared successfully.', life: 3000 });
      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      // this.addMsgCB(data);

      // close the dialogBox
      // dialogRef.close();
    });
  }

  }
